"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateHideCurrentYear = exports.formatDate = exports.SHOWTIME_FORMAT_DISPLAY = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
exports.SHOWTIME_FORMAT_DISPLAY = "ddd MMM D, YYYY h:mm A";
const formatDate = (fullDateString, options) => {
    let format = options?.format ? options.format : exports.SHOWTIME_FORMAT_DISPLAY;
    const hide_year_if_current = options?.hide_year_if_current
        ? options.hide_year_if_current
        : false;
    const hide_day = options?.hide_day ? options.hide_day : false;
    if (hide_year_if_current) {
        const date = (0, dayjs_1.default)(fullDateString);
        if (date.get("year") === (0, dayjs_1.default)().get("year")) {
            format = format.replace("YYYY ", "");
        }
    }
    if (hide_day) {
        format = format.replace("ddd ", "");
    }
    return (0, dayjs_1.default)(fullDateString).format(format);
};
exports.formatDate = formatDate;
const formatDateHideCurrentYear = (fullDateString) => {
    return (0, exports.formatDate)(fullDateString, { hide_year_if_current: true });
};
exports.formatDateHideCurrentYear = formatDateHideCurrentYear;
//# sourceMappingURL=format-date.js.map